/* # Main Application Layout
   - Wraps the entire authenticated application
   - Includes Header and Sidebar with mobile responsiveness
   - Implements accessibility features for main content area
*/
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar';
import Header from './Header';

export default function MainLayout() {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Skip Link for Accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 z-[100] bg-blue-600 text-white px-4 py-2 rounded-lg font-bold shadow-lg transition-all">

        {t('common.skipToContent')}
      </a>

      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Main Content Area - Localized with ARIA labels */}
        <main
          id="main-content"
          className="flex-1 overflow-y-auto p-4 lg:p-6"
          role="main"
          aria-label={t('common.mainContent')}>

          <Outlet />
        </main>
      </div>
    </div>);

}